import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './style.css';

const Donut = ({
  value,
}) => (
  <div
    className={cx('donut', {
      'donut--high': value > 590,
      'donut--low': value <= 590,
    })}
  >
    <div className="donut__value">{value}</div>
  </div>
);

Donut.propTypes = {
  value: PropTypes.number.isRequired,
};

export default Donut;



// WEBPACK FOOTER //
// ./src/components/Donut/index.js